/**
 * LanguageSettingItems
 * 
 * @Author: Focci
 * @Date: 2023-09-20 21:12:11
 * @Last Modified by: Focci
 * @Last Modified time: 2023-09-20 21:12:11
 */

'use client'

import PropTypes from 'prop-types'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { ButtonBase } from '@comp/material'
import clsx from 'clsx'

export default function LanguageSettingItems({
  value,
  options = [],
  onChange = () => {}
}) {
  return (
    <div className="grid grid-cols-2 gap-4">
      {options.map((opt) => {
        const selected = opt.value === value
        return (
          <ButtonBase
            className="rounded-md w-full"
            key={opt.value}
            onClick={() => onChange(opt)}
          >
            <div
              className={clsx([
                'flex items-center justify-between rounded-md bg-cf8 px-2 py-2',
                'w-40 max-w-full cursor-pointer border w-full',
                selected ? 'border-helper' : 'border-transparent'
              ])}
            >
              <div className="flex items-center gap-x-1">
                {opt.icon}
                <span>{opt.label}</span>
              </div>
              <div className={clsx([selected ? 'text-primary' : 'text-helper'])}>
                <CheckCircleIcon />
              </div>
            </div>
          </ButtonBase>
        )
      })}
    </div>
  )
}

LanguageSettingItems.propTypes = {
  value: PropTypes.any,
  options: PropTypes.array,
  onChange: PropTypes.func,
}
